export default {"src":"/_next/static/media/member-using-app.colour.4640e187.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};